import { makeStyles } from "@material-ui/core/styles";
import getCommonStyles from './_common';

const useServicesStyles = makeStyles((theme) => ({
  ...getCommonStyles(theme),
  root: {
    ...getCommonStyles(theme).sectionContainer,
    position: 'relative',
    background: 'transparent',
    padding: theme.spacing(10, 0, 10),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(7, 0, 7),
    },
  },
  serviceContainer: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 2, 0),
    },
    padding: theme.spacing(8, 4, 0),
    margin: "50px auto 0",
    position: "relative",
    width: " 95%",
    borderRadius: "10px",
  },
  serviceContent: {
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(0, 4, 6),
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  sectionTitle: {
    ...getCommonStyles(theme).sectionTitle,
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1.08,
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontSize: '3rem',
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  sectionDescription: {
    ...getCommonStyles(theme).sectionDescription,
    color: '#b5c3d3',
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontSize: '1.1rem',
    lineHeight: 1.85,
    maxWidth: 880,
    margin: '0 auto',
    textAlign: 'center',
  },
  serviceTitle: {
    background: 'linear-gradient(135deg, rgba(0, 212, 170, 0.12) 0%, rgba(25, 183, 230, 0.10) 100%)',
    color: '#f8fdff',
    padding: theme.spacing(1.75, 2.5),
    borderTop: '1px solid rgba(0, 212, 170, 0.18)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
    fontSize: '1.05rem',
    fontWeight: 700,
  },
  serviceCard: {
    transition: "transform 0.4s ease",
    '&:hover': {
      transform: "translateY(-10px)",
    },
    '&:hover $card': {
      borderColor: 'rgba(0, 212, 170, 0.35)',
      boxShadow: "0 32px 80px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(0, 212, 170, 0.08)",
    },
    '&:hover $card::before': {
      opacity: 1,
      transform: 'scaleX(1)',
    },
  },
  card: {
    position: 'relative',
    borderRadius: "20px",
    overflow: "hidden",
    background: 'linear-gradient(180deg, rgba(15, 30, 52, 0.92) 0%, rgba(7, 16, 29, 0.92) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: "0 18px 44px rgba(0, 0, 0, 0.22)",
    backdropFilter: 'blur(14px)',
    transition: "box-shadow 0.4s ease, border-color 0.4s ease",
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: 'linear-gradient(90deg, #00d4aa 0%, #19b7e6 100%)',
      opacity: 0.55,
      transform: 'scaleX(0.35)',
      transformOrigin: 'left center',
      transition: 'opacity 280ms ease, transform 420ms cubic-bezier(0.22, 1, 0.36, 1)',
      zIndex: 2,
      borderRadius: '20px 20px 0 0',
    },
  },
  digitalMediaCard: {
    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.18) 0%, rgba(0, 212, 170, 0.18) 100%), linear-gradient(180deg, rgba(15, 30, 52, 0.92) 0%, rgba(7, 16, 29, 0.92) 100%)',
    '&::before': {
      opacity: 0.85,
      transform: 'scaleX(1)',
    },
  },
  media: {
    height: 0,
    paddingTop: "55%",
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(180deg, rgba(6, 17, 31, 0.15) 0%, rgba(6, 17, 31, 0.55) 100%)',
      pointerEvents: 'none',
    },
  },
  title: {
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 700,
    fontSize: '1.05rem',
    color: '#f8fdff',
    letterSpacing: '-0.005em',
  },
  cardDescription: {
    background: 'transparent',
    padding: theme.spacing(2.25, 2.5, 2.5),
    minHeight: '72px',
  },
  descriptionText: {
    color: '#aebccc',
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontSize: '0.92rem',
    lineHeight: 1.6,
    textAlign: 'left',
  },
  dialogPaper: {
    borderRadius: '22px',
    overflow: 'hidden',
    background: 'linear-gradient(180deg, rgba(11, 22, 38, 0.98) 0%, rgba(8, 17, 31, 0.98) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    boxShadow: '0 35px 120px rgba(0, 0, 0, 0.45)',
  },
  dialogTitle: {
    background: 'linear-gradient(135deg, rgba(0, 212, 170, 0.12) 0%, rgba(25, 183, 230, 0.10) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    color: '#fff',
    padding: theme.spacing(2.5, 3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogTitleText: {
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    color: '#f8fdff',
    letterSpacing: '-0.01em',
  },
  closeButton: {
    color: '#d6e4ef',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    background: 'linear-gradient(180deg, rgba(8, 17, 31, 0.88) 0%, rgba(10, 21, 37, 0.92) 100%)',
  },
  dialogImage: {
    width: '100%',
    maxHeight: '300px',
    objectFit: 'cover',
    borderRadius: '14px',
    marginBottom: theme.spacing(3),
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
    border: '1px solid rgba(255, 255, 255, 0.06)',
  },
  dialogSubtitle: {
    color: '#86f8e1',
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontSize: '1.05rem',
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: theme.spacing(2.5),
    padding: theme.spacing(1.5, 2),
    background: 'rgba(0, 212, 170, 0.1)',
    border: '1px solid rgba(0, 212, 170, 0.25)',
    borderRadius: '12px',
    borderLeft: '3px solid #00d4aa',
  },
  dialogDescription: {
    color: '#c2d2e0',
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    fontSize: '1rem',
    lineHeight: 1.85,
    padding: theme.spacing(1, 0),
    '& strong': {
      color: '#f8fdff',
    },
  },
}));
export default useServicesStyles;
